import styled from '@emotion/styled'
import { Box, TableBody, Typography } from '@mui/material'

export const CampaignMagnetScoreWrap = styled(Box)(`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    position: relative;
    width: 100%;
    padding: 0;
    min-height: 40px;
`)

export const StyledHeading = styled(Typography)(`
    font-size: 12px;
    max-width: 120px;
    line-height: 14px;
    font-weight: 400;
    margin-right: 8px;
    position: absolute;
    left: -140px;
    width: 100%;
`)

export const ChartWrapper = styled(Box)(`
    width:100%;
    display: flex;
    align-items: center;
    border: 1px #E7E7E6 solid;
    padding: 4px;
    background: #fff;
    position: relative;
`)

export const AdditionalInfo = styled(Box)(`
    font-size: 12px;
    font-weight: 400;
    margin-left: 2px;
    color: #2734DA;
    width: 35px;
`)

export const SectionRowWrap = styled(Box)(`
   display: flex;
   justify-content: space-between;
   align-items: center;
   & .headerTitle {
    font-size: 20px;
    font-weight: 400; // 300;
   }
   & .iconWrap {
    display: flex;
    align-items: center;
        & .rightLink {
            font-size: 14px;
            font-weight: 400; // 300;
            color: #095BBD;
            margin-right: 5px;
        }
   }
`)

export const LegendRowWrap = styled(Box)(`
   display: flex;
   justify-content: end;
   align-items: center;
   padding: 16px 0 0 0;
   margin-bottom: 50px;
`)

export const SmallGraphWrapper = styled(Box)(`
   display: flex;
   justify-content: center;
   align-items: center;
   background: #F9F4E3;
   width: 100px;
   height: 60px;
`)

export const InteractionWrap = styled(Box)(`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 8px;

    & .barSlice {
      & .barSliceLabel {
          font-weight: 400;
          top: 28px;
          position: absolute;
          white-space: nowrap;
          z-index: 1;
          color: #000;
          left: -5px;
      }
    }
`)

export const TableWrap = styled(Box)(`
    & table {
        margin-top:0;
    }
    & th {
        text-transform:none !important;
        // background: #F1F1F3;
        padding: 12px 4px;
        font-weight: 600;
        text-align: left;
    }
    & th > div {
        padding: 11px;
    }
    & th:nth-of-type(1) {
        visibility: visible;
    }

    & td {
        padding: 0px 4px;
        vertical-align: middle;
        border: 0;
    }

    & td:last-child {
        padding: 0px 4px 0 0 !important;
    }

    & tr:nth-of-type(even) td {
        background-color: #fff;
    }

    & tr:hover td {
        background-color: #FAFAFA;
    }

    & td .triggerName {
        width: 90%;
        line-height: 18px;
        min-height: 40px;
        display: flex;
        align-items: center;
        text-align: left;
    }

    & td .campaignMagnetScore {
        padding: 0;
    }

    & td .engagementValue {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 500;
        min-height: 40px;
    }
`)
